import type { Form } from 'payments-lib-types';
import { type FC, useState } from 'react';

import { FormGroup } from '@/components/form/groups/FormGroup';
import { Select } from '@/components/form/Select';
import { IconComponent } from '@/components/IconComponent';
import { required } from '@/helpers/validators';
import { useWithdrawStore } from '@/store';
import type { OfUnion } from '@/types/common';
import { ScCryptoBlock } from './styled';

const PROTOCOL_TRC20 = 'TRC20';

const setDefaultProtocol =
  (defaultProtocol: string) => (protocols: string[]) => {
    if (protocols.includes(defaultProtocol)) {
      return defaultProtocol;
    }

    return protocols[0];
  };

const setTRC20Protocol = setDefaultProtocol(PROTOCOL_TRC20);

export type FieldMultiProtocolCryptoAddressType =
  OfUnion<Form.MethodField>[Form.MethodFieldType.MultiProtocolCryptoAddress];

export const FieldMultiProtocolCryptoAddress: FC<
  FieldMultiProtocolCryptoAddressType
> = ({ fieldName, protocols, bannersByProtocol }) => {
  const activeThemeMode = useWithdrawStore.use.activeThemeMode();

  const [selectedProtocol, setSelectedProtocol] = useState(
    setTRC20Protocol(protocols)
  );

  const protocolOptions = protocols.map((protocol) => ({
    name: protocol,
    value: protocol,
  }));

  return (
    <ScCryptoBlock mode={activeThemeMode}>
      <FormGroup mode={activeThemeMode} title="Select protocol" wide>
        <Select
          initialValue={selectedProtocol}
          mode={activeThemeMode}
          name={fieldName}
          onSelectOption={(event) =>
            typeof event === 'string' && setSelectedProtocol(event)
          }
          options={protocolOptions}
          placeholder="Select protocol"
          validate={required}
        />
      </FormGroup>
      <div className="info">
        <div className="info-inner">
          <IconComponent name="tooltipIcon" />
          <div
            dangerouslySetInnerHTML={{
              __html: bannersByProtocol[selectedProtocol][0].htmlContent,
            }}
          />
        </div>
      </div>
    </ScCryptoBlock>
  );
};
